import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _Config } from "@discovery/common-dplus/lib/state";
import { _Col2TemplateId, _ColAttributes2Title, } from "@discovery/sonic-api-ng-optics";
import { _ExploreLiveChannelLists, _ExploreShowLists } from "./optics";
const ExploreListOfShows = React.lazy(() => import("../explore-shows/explore-shows-lists"));
const LiveChannelListView = React.lazy(() => import("../explore-shows/live-channel-lists"));
export var ExploreTemplateId;
(function (ExploreTemplateId) {
    ExploreTemplateId["LIVE"] = "live";
    ExploreTemplateId["BASIC"] = "basic";
    ExploreTemplateId["DESCRIPTIVE"] = "descriptive";
    ExploreTemplateId["VIEW_ALL"] = "pwa-view-all";
})(ExploreTemplateId || (ExploreTemplateId = {}));
const getProps = (data) => {
    const exploreLiveChannelLists = Fold.toArray(_ExploreLiveChannelLists, data);
    const exploreShowsList = Fold.toArray(_ExploreShowLists, data);
    const titleM = M.fromMaybe(Fold.preview(_ColAttributes2Title, data), M.of(""));
    const templateIdM = Fold.preview(_Col2TemplateId, data);
    const templateId = M.fromMaybe(templateIdM, "");
    const title = M.fromMaybe(titleM, "");
    return {
        exploreLiveChannelLists,
        exploreShowsList,
        templateId,
        title,
    };
};
const ExploreLandingPage = ({ exploreLiveChannelLists, exploreShowsList, templateId, title, environment, }) => {
    const [configM] = useGlobalState(_Config);
    //Config
    const parentalLockM = M.chain((x) => x.parentalLock, configM);
    const ageRestrictedChannelsM = M.chain((x) => x.ageRestrictedChannels, parentalLockM);
    const ageRestrictedChannels = M.fromMaybe(ageRestrictedChannelsM, [""]);
    return templateId === ExploreTemplateId.LIVE ? (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(LiveChannelListView, { liveChannelLists: exploreLiveChannelLists, title: title, islive: true }))) : (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(ExploreListOfShows, { exploreShowsList: exploreShowsList, ageRestrictedChannels: ageRestrictedChannels, read: environment, title: title })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, ExploreLandingPage);

